module.exports = __webpack_public_path__ + "img/history_bg.442af134.png";